<template>
    <v-app class="myprovet-bg-color" v-resize="onResize">
        <div class="my-4" :class="calculateOuterNavBarSpacing()">
            <div class="d-flex align-center" :class="calculateInnerNavBarSpacing()">
                <template v-if="showMobileSidebar">
                    <v-navigation-drawer v-model="appStore.nav_drawer" absolute temporary :width="calculateNavDrawerWidth()">
                        <div class="pa-8">
                            <inertia-link href="/dashboard">
                                <v-img contain :src="logoUrl"></v-img>
                            </inertia-link>
                        </div>
                        <div class="pa-4" id="bar_client_menu" v-if="isMobile">
                            <app-bar-client-menu :disabled="!showingMultipleBranches" :isScrollable="true">
                                <template v-slot:default="slotProps">
                                    <div class="d-flex align-center" v-bind="slotProps.event.attrs" v-on="slotProps.event.on" data-cy="navbar-client" :style="showingMultipleBranches ? '' : 'cursor: default'" style="width: 100%">
                                        <v-icon :class="getBranchColor" class="appbar-icon-button-small elevation-0 no-background-hover dark-blue-color">
                                            {{ getBranchIcon }}
                                        </v-icon>

                                        <v-col class="pl-2 py-0">
                                            <div class="pb-0 d-flex justify-start align-center">
                                                <span v-if="getBranch" class="mt-1 navbar-client-name font-size-sm font-weight-bold dark-blue-color">
                                                    <span>{{ getBranch }}</span>
                                                </span>
                                            </div>
                                        </v-col>

                                        <v-btn v-if="showingMultipleBranches" icon class="appbar-icon-button-small btn-bg-color-white elevation-0">
                                            <v-icon class="dark-blue-color">mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </app-bar-client-menu>
                        </div>

                        <slot name="categories" />
                    </v-navigation-drawer>

                    <v-app-bar-nav-icon class="mr-2" @click.stop="toggleNavDrawer"></v-app-bar-nav-icon>
                </template>

                <v-col id="logo" :cols="3" :class="showMobileSidebar?' myprovet-icon-min-width logo-v2 '+ classlogo :''" class="px-0 py-0 d-flex flex-column">
                    <div class="d-flex align-start justify-start" v-if="renderImage()" style="max-height: 65px">
                        <inertia-link href="/dashboard">
                            <v-img max-width="212px" class="pl-6 mr-2 shepherd-dashboard-link" contain :src="logoUrl2"></v-img>
                        </inertia-link>
                    </div>
                </v-col>

                <slot name="navbar" />
            </div>
        </div>
        <div class="mobile-search" v-if="isSearchMobile">
            <v-col cols="12" class="pt-0" v-if="isMobile">
                <div class="d-flex shepherd-navbar-search " :class="''" style="width: inherit; width: 100%">
                        <v-form style="width: 100%" @submit.prevent="">
                            <v-text-field
                                v-model.trim="search"
                                dense
                                solo
                                flat
                                :placeholder="$t('layout.search')"
                                height="40px"
                                prepend-inner-icon="mdi-magnify"
                                hide-details
                                class="navbar-search-text-field btn-bg-color-white dark-blue-color elevation-0"
                                style="border-radius: 20px"
                                @click:prepend-inner="searchProducts"
                                @keyup.enter="searchProducts"
                            ></v-text-field>
                        </v-form>
                    </div>
            </v-col>

        </div>
        <v-row class="pb-3 mb-0 d-flex flex-row flex-nowrap" :class="showMobileSidebar ? 'mx-4' : 'px-4 mx-16'">
            <v-col id="sidebar_categories" cols="3" :class="showMobileSidebar?'mr-0 d-flex flex-column no-flex':'mr-0 d-flex flex-column'" v-if="hasSlot('desktop-optional')">
                <slot v-if="!showMobileSidebar" name="desktop-categories" />
                <slot name="desktop-optional" :alone="showMobileSidebar" />
            </v-col>

            <v-col id="sidebar_categories" :cols="getCategoriesCols" :style="getCategoriesStyle" class="mr-0 d-flex flex-column" v-else-if="!showMobileSidebar">
                <slot name="desktop-categories" />
            </v-col>

            <v-col :class="categoriesStore.isCategoriesCardCollapsed?'d-flex flex-column collapsed':'d-flex flex-column' " id="pg_content">
                <slot />
            </v-col>
        </v-row>

        <app-footer></app-footer>

        <t-notifications></t-notifications>

        <!-- While showing a tutorial, also disable interactions with the tutorial targets -->
        <div :class="shepherdOverlayActive ? 'shepherd-overlay' : ''"></div>
    </v-app>
</template>

<script>
import { mapStores } from 'pinia';
import { useCategoriesStore } from '@/Stores/categories';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import AppFooter from '../Components/AppFooter';
import TNotifications from './TNotifications';

export default {
    components: { AppFooter, TNotifications },

    data() {
        return {
            search:'',
            nav: {
                drawer: false,
                group: null,
            },

            shepherdOverlayActive: false,

            logoUrl: '/storage/assets/appbar/appbar_logo.png',
            logoUrl2: '/storage/assets/appbar/slim_logo.png',
            classlogo:'appbar-logo'
        };
    },

    created() {
        window.EventBus.$on('add-tutorial-overlay', () => {
            this.shepherdOverlayActive = true;
        });
        window.EventBus.$on('remove-tutorial-overlay', () => {
            this.shepherdOverlayActive = false;
        });
        /*window.EventBus.$on('close-nv-drawer', () => {
            this.$nextTick(_=>{
                this.nav.drawer = false;
            })
        });*/

        let portrait = window.matchMedia("(orientation: portrait)");
        //console.log('portrait',portrait)

        this.logoUrl2 = portrait.matches || window.innerWidth<=1180?'/storage/assets/appbar/slim_logo.png':this.logoUrl
        this.classlogo = portrait.matches || window.innerWidth<=1180?'slim-logo':'appbar-logo'

        portrait.addEventListener("change", (e)=> {
             //console.log('in',e,window.innerWidth, portrait.matches)
            if(e.matches) {
                // Portrait mode
                this.logoUrl2 = window.innerWidth<=1180?'/storage/assets/appbar/slim_logo.png':this.logoUrl
                this.classlogo = portrait.matches || window.innerWidth<=1180?'slim-logo':'appbar-logo'

            } else {
                // Landscape
                this.logoUrl2 = window.innerWidth<=1180?'/storage/assets/appbar/slim_logo.png':this.logoUrl
                this.classlogo = portrait.matches || window.innerWidth<=1180?'slim-logo':'appbar-logo'
            }
        })
        /*if(this.isMobile){
            //console.log('window.innerWidth',window.innerWidth,screen.orientation);
            screen.orientation.lock('portrait').then(() => {
                console.log('Locked to portrait');
            })
            .catch((error) => {
                //log.textContent += `${error}\n`;
                //console.log('Locked error',error);
            });
        }else{
                //console.log('window.innerWidth unlock',window.innerWidth,screen.orientation);
            screen.orientation.unlock()
        }*/

    },
    mounted(){
        document.addEventListener('dblclick', function (e) {
            e.preventDefault();
        }, { passive: false });
    },
    beforeDestroy() {
        window.EventBus.$off('add-tutorial-overlay');
        window.EventBus.$off('remove-tutorial-overlay');
        //window.EventBus.$off('close-nv-drawer');
    },
    beforeMount(){
        window.addEventListener("beforeunload", this.preventNav);
        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("beforeunload", this.preventNav);
        });
    },
    computed: {
        ...mapStores(useCategoriesStore,useUserStore,useBranchStore,useAppStore),

        getCategoriesCols() {
            return this.categoriesStore.isCategoriesCardCollapsed ? 1 : 3;
        },

        getCategoriesStyle() {
            return this.categoriesStore.isCategoriesCardCollapsed ? 'flex: 0 0 95px;' : '';
        },

        showMobileSidebar() {
            //console.log(' showMobileSidebar',['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name),this.$vuetify.breakpoint.name);
            return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name);
        },
        showingMultipleBranches() {
            return this.userStore.branchCount > 1 || this.userStore.hasPermissionTo('Access all clients and branches');
        },
        getBranch() {
            if (!this.branchStore.branch) return '';

            const name = this.branchStore.branch.name;
            const branch_id = this.branchStore.branch.id;

            // @Note: Get pending products for the selected branch
            if (this.userStore.hasPermissionTo('View pending products')) {
                this.getBranchPendingProducts(branch_id);
            }

            return this.userStore.hasPermissionTo('View client and branch number') ? `(${branch_id}) ${name} ` : name;
        },

        getBranchIcon() {
            const branch = this.branchStore.branch;
            if (!branch) return '';

            return branch.is_petfood ? 'mdi-alpha-p' : 'mdi-alpha-f';
        },

        getBranchColor() {
            const branch = this.branchStore.branch;
            if (!branch) return '';

            return branch.is_petfood ? 'btn-bg-color-navbar-petfood-inactive' : 'btn-bg-color-blue';
        },
        isMobile(){
            return this.appStore.is_mobile
        },
        isSearchMobile(){
            return this.appStore.is_search_mobile
        }
    },

    methods: {
        toggleNavDrawer(){
            let drawer= this.appStore.drawer ?false:true
            this.appStore.setNavDrawer(drawer)
        },
        preventNav(event){
            //console.log('preventNav',event,this.isMobile);
            if(this.isMobile){
                /*if(!window.confirm("Tem a certeza que pretende refrescar a página?")){
                    return
                }*/
                if(this.appStore.click_banner){
                    this.appStore.setClickBanner(false)
                   return
                }else{
                    event.preventDefault()
                    // Chrome requires returnValue to be set.
                    event.returnValue = ""
                }

            }else{
                this.appStore.setClickBanner(false)
            }
        },
        searchProducts() {
            const url = route('order.normal', { q: this.search });

            // After searching something we need to clear it to avoid
            //  misunderstandings if we're already in the orders page.
            this.search = '';
            this.appStore.setSearchMobile(!this.appStore.is_search_mobile)
            this.$inertia.visit(url);
        },
        onResize(){
            //console.log('onResize',window.innerWidth)
            this.logoUrl2 = window.innerWidth<=1036?'/storage/assets/appbar/slim_logo.png':this.logoUrl
            this.classlogo =  window.innerWidth<=1036?'slim-logo':'appbar-logo'
            if(window.innerWidth<767){
                this.appStore.setIsMobile(true)
                if(window.innerWidth>600){
                    this.appStore.setMobileLS(true)
                }else{
                    this.appStore.setMobileLS(false)
                }
                this.appStore.setIsTablet(false)
            }else if(window.innerWidth>=767 && window.innerWidth<=1366){
                this.appStore.setIsMobile(false)
                this.appStore.setMobileLS(false)
                this.appStore.setIsTablet(true)
                //const userAgent = navigator.userAgent.toLowerCase();
                //const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
                //console.log(isTablet,userAgent)
            }else{
                this.appStore.setIsMobile(false)
                this.appStore.setMobileLS(false)
                this.appStore.setIsTablet(false)
            }
        },
        getBranchPendingProducts(branch_id) {
            this.pendingProducts = [];

            axios
                .get(`/api/orders/has-pending-products/${branch_id}`)
                .then((response) => {
                    this.pendingProducts = response.data;
                    this.pendingProducts.length > 0 ? this.branchStore.setHasPendingProducts(true) : this.branchStore.setHasPendingProducts(false);
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('layout.pendingProductsError'));
                    this.branchStore.setHasPendingProducts(false);
                });
        },

        hasSlot(name = 'default') {
            return !!this.$slots[name] || !!this.$scopedSlots[name];
        },

        renderImage() {
            return true
            //return this.$vuetify.breakpoint.name !== 'xs';
        },

        calculateOuterNavBarSpacing() {
            return ['lg', 'xl'].includes(this.$vuetify.breakpoint.name) ? 'px-4 mx-16' : 'mx-2';
        },

        calculateInnerNavBarSpacing() {
            return ['lg', 'xl'].includes(this.$vuetify.breakpoint.name) ? 'mx-3' : '';
        },

        calculateNavDrawerWidth() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
                return '70%';
            case 'sm':
                return '50%';
            case 'md':
                return '38%';
            case 'lg':
                return '25%';
            case 'xl':
            default:
                return '20%';
            }
        },
    },
};
</script>

<style>
html {
    overflow-y: auto !important;
    -ms-overflow-style: none; /* IE 11 */
}

/* Scroll style */
@-moz-document url-prefix() {
    /* Firefox specific CSS: remove the default scrollbar. */
    * {
        scrollbar-width: thin !important;
        scrollbar-color: #154579 transparent;
    }
}

/* width */
::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar:horizontal {
    height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #006DB6;
    /*background: #154579;*/
    border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    /*background: #2cbadb;*/
    background:#42aedf;
    border-radius: 8px;
}
/* End of scroll style */

.myprovet-icon-min-width {
    min-width: 220px !important;
}
#sidebar_categories.no-flex{
      flex: 0!important;
      display: none!important;
}
</style>

<style scoped>
.shepherd-overlay {
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: 0;
    background-color: black;
    width: 100%;
    z-index: 999;
    height: 100%;
}
</style>
